import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 264 107",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "76",
      y: "33",
      width: "112",
      height: "40",
      rx: "8",
      fill: "var(--dt-action-color-background-base-primary-default)",
      id: "button-bg"
    }, null, -1),
    _createElementVNode("rect", {
      x: "104",
      y: "49",
      width: "56",
      height: "8",
      rx: "4",
      fill: "var(--dt-action-color-foreground-base-primary-default)",
      id: "Rectangle 494"
    }, null, -1)
  ]))]))
}
export default { render: render }